(function () {
  'use strict';

  var BMI_BANDS = [
    { max: 19,        size: 'XS' },
    { max: 22,        size: 'S' },
    { max: 25,        size: 'M' },
    { max: 28.5,      size: 'L' },
    { max: 32,        size: 'XL' },
    { max: Infinity,  size: 'XXL' }
  ];

  var TALL_CM = 172;
  var PETITE_CM = 158;
  var BOUNDARY_MARGIN = 1.5;

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '3XL'];

  var CM_PER_IN = 2.54;
  var LB_PER_KG = 2.20462262185;

  var LOCALE = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();

  var I18N = {
    en: {
      opener: 'Find your size', modalTitle: 'Find your size', modalSubtitle: 'Fill in your details and find your recommended size.',
      age: 'Age', gender: 'Gender', female: 'Female', male: 'Male', preferNotToSay: 'Prefer not to say',
      height: 'Height', weight: 'Weight', continueBtn: 'Continue', orEnterExact: 'Or enter your exact measurements',
      measureTitle: 'Enter your measurements', measureSubtitle: 'Fill in as many as you can — we’ll match them to this product’s own size chart for the most accurate fit.',
      back: 'Back', resultTitle: 'Your recommended size', resultSubtitle: 'There’s a good chance that this size will fit well on you.',
      selectThisSize: 'Select this size', tryAgain: 'Try again',
      disclaimer: 'This is a recommendation only. For the most accurate fit, please also check this product’s detailed measurements in the Size Guide and consider its designed fit (oversized, relaxed, true to size, etc.).',
      close: 'Close', errorHeightWeight: 'Please enter your height and weight.',
      errorNoMeasurements: 'Exact measurements aren’t available for this product yet — please use the quiz above instead.',
      errorEnterOne: 'Please enter at least one measurement.', basedOn: 'Based on', fitLabel: 'Fit', fitPreference: 'Fit preference',
      waistStretchHalf: 'This style has a half-elastic waistband, which typically allows about 5–6 cm of additional stretch.',
      waistStretchFull: 'This style has a fully elastic waistband, which typically allows about 7–9 cm of additional stretch.',
      shouldersTitle: 'Your shoulders', shouldersSubtitle: 'Define your shoulder width to help us identify your perfect fit.',
      chestTitle: 'Your chest', chestSubtitle: 'Define your chest shape to help us identify your perfect fit.',
      waistTitle: 'Your waist', waistSubtitle: 'Define your waist width to help us identify your perfect fit.',
      fitTitle: 'Your preferred fit', fitSubtitle: 'Define your preferred fit to help us identify your perfect size.',
      hipsTitle: 'Your hips', hipsSubtitle: 'Define your hip width to help us identify your perfect fit.',
      slimmer: 'Slimmer', average: 'Average', wider: 'Wider', flatter: 'Flatter', broader: 'Broader', tighter: 'Tighter', looser: 'Looser', narrower: 'Narrower'
    },
    de: {
      opener: 'Finde deine Größe', modalTitle: 'Finde deine Größe', modalSubtitle: 'Gib deine Angaben ein und finde deine empfohlene Größe.',
      age: 'Alter', gender: 'Geschlecht', female: 'Weiblich', male: 'Männlich', preferNotToSay: 'Keine Angabe',
      height: 'Körpergröße', weight: 'Gewicht', continueBtn: 'Weiter', orEnterExact: 'Oder gib deine genauen Maße ein',
      measureTitle: 'Gib deine Maße ein', measureSubtitle: 'Trag so viele wie möglich ein — wir gleichen sie mit der Maßtabelle dieses Produkts ab, um die genaueste Passform zu finden.',
      back: 'Zurück', resultTitle: 'Deine empfohlene Größe', resultSubtitle: 'Diese Größe passt dir mit hoher Wahrscheinlichkeit gut.',
      selectThisSize: 'Diese Größe auswählen', tryAgain: 'Erneut versuchen',
      disclaimer: 'Dies ist nur eine Empfehlung. Sieh dir für die genaueste Passform bitte auch die detaillierten Maße dieses Produkts in der Größentabelle an und berücksichtige den Schnitt (oversized, locker, normal usw.).',
      close: 'Schließen', errorHeightWeight: 'Bitte gib deine Körpergröße und dein Gewicht ein.',
      errorNoMeasurements: 'Für dieses Produkt sind noch keine genauen Maße verfügbar — bitte nutze stattdessen das Quiz oben.',
      errorEnterOne: 'Bitte gib mindestens ein Maß ein.', basedOn: 'Basierend auf', fitLabel: 'Passform', fitPreference: 'Bevorzugte Passform',
      waistStretchHalf: 'Dieser Schnitt hat einen halbelastischen Bund, der in der Regel etwa 5–6 cm zusätzliche Dehnung bietet.',
      waistStretchFull: 'Dieser Schnitt hat einen vollelastischen Bund, der in der Regel etwa 7–9 cm zusätzliche Dehnung bietet.',
      shouldersTitle: 'Deine Schultern', shouldersSubtitle: 'Definiere deine Schulterbreite, damit wir deine perfekte Passform bestimmen können.',
      chestTitle: 'Deine Brust', chestSubtitle: 'Definiere deine Brustform, damit wir deine perfekte Passform bestimmen können.',
      waistTitle: 'Deine Taille', waistSubtitle: 'Definiere deine Taillenbreite, damit wir deine perfekte Passform bestimmen können.',
      fitTitle: 'Deine bevorzugte Passform', fitSubtitle: 'Definiere deine bevorzugte Passform, damit wir deine perfekte Größe bestimmen können.',
      hipsTitle: 'Deine Hüften', hipsSubtitle: 'Definiere deine Hüftbreite, damit wir deine perfekte Passform bestimmen können.',
      slimmer: 'Schmaler', average: 'Durchschnittlich', wider: 'Breiter', flatter: 'Flacher', broader: 'Breiter', tighter: 'Enger', looser: 'Weiter', narrower: 'Schmaler'
    },
    fr: {
      opener: 'Trouvez votre taille', modalTitle: 'Trouvez votre taille', modalSubtitle: 'Renseignez vos informations pour trouver votre taille recommandée.',
      age: 'Âge', gender: 'Genre', female: 'Femme', male: 'Homme', preferNotToSay: 'Ne pas préciser',
      height: 'Taille', weight: 'Poids', continueBtn: 'Continuer', orEnterExact: 'Ou indiquez vos mesures exactes',
      measureTitle: 'Indiquez vos mesures', measureSubtitle: 'Renseignez-en autant que possible — nous les comparerons au tableau des tailles de ce produit pour la taille la plus juste possible.',
      back: 'Retour', resultTitle: 'Votre taille recommandée', resultSubtitle: 'Il y a de grandes chances que cette taille vous convienne parfaitement.',
      selectThisSize: 'Choisir cette taille', tryAgain: 'Réessayer',
      disclaimer: 'Ceci est une recommandation uniquement. Pour la taille la plus juste, consultez également les mesures détaillées de ce produit dans le Guide des tailles et tenez compte de sa coupe (oversize, ample, ajustée, etc.).',
      close: 'Fermer', errorHeightWeight: 'Veuillez indiquer votre taille et votre poids.',
      errorNoMeasurements: 'Les mesures exactes ne sont pas encore disponibles pour ce produit — veuillez utiliser le quiz ci-dessus.',
      errorEnterOne: 'Veuillez indiquer au moins une mesure.', basedOn: 'Basé sur', fitLabel: 'Coupe', fitPreference: 'Coupe préférée',
      waistStretchHalf: 'Ce modèle a une ceinture semi-élastique, qui permet généralement environ 5 à 6 cm d’extensibilité supplémentaire.',
      waistStretchFull: 'Ce modèle a une ceinture entièrement élastique, qui permet généralement environ 7 à 9 cm d’extensibilité supplémentaire.',
      shouldersTitle: 'Vos épaules', shouldersSubtitle: 'Définissez la largeur de vos épaules pour nous aider à déterminer votre coupe idéale.',
      chestTitle: 'Votre poitrine', chestSubtitle: 'Définissez la forme de votre poitrine pour nous aider à déterminer votre coupe idéale.',
      waistTitle: 'Votre taille', waistSubtitle: 'Définissez la largeur de votre taille pour nous aider à déterminer votre coupe idéale.',
      fitTitle: 'Votre coupe préférée', fitSubtitle: 'Définissez votre coupe préférée pour nous aider à déterminer votre taille idéale.',
      hipsTitle: 'Vos hanches', hipsSubtitle: 'Définissez la largeur de vos hanches pour nous aider à déterminer votre coupe idéale.',
      slimmer: 'Plus fines', average: 'Moyennes', wider: 'Plus larges', flatter: 'Plus plate', broader: 'Plus large', tighter: 'Plus ajustée', looser: 'Plus ample', narrower: 'Plus fines'
    },
    nl: {
      opener: 'Vind jouw maat', modalTitle: 'Vind jouw maat', modalSubtitle: 'Vul je gegevens in en ontdek je aanbevolen maat.',
      age: 'Leeftijd', gender: 'Geslacht', female: 'Vrouw', male: 'Man', preferNotToSay: 'Zeg ik liever niet',
      height: 'Lengte', weight: 'Gewicht', continueBtn: 'Doorgaan', orEnterExact: 'Of vul je exacte maten in',
      measureTitle: 'Vul je maten in', measureSubtitle: 'Vul zoveel mogelijk in — we vergelijken ze met de maattabel van dit product voor de nauwkeurigste pasvorm.',
      back: 'Terug', resultTitle: 'Jouw aanbevolen maat', resultSubtitle: 'De kans is groot dat deze maat je goed past.',
      selectThisSize: 'Deze maat selecteren', tryAgain: 'Opnieuw proberen',
      disclaimer: 'Dit is slechts een aanbeveling. Bekijk voor de nauwkeurigste pasvorm ook de gedetailleerde maten van dit product in de maattabel en houd rekening met de coupe (oversized, los, normale pasvorm, enz.).',
      close: 'Sluiten', errorHeightWeight: 'Vul je lengte en gewicht in.',
      errorNoMeasurements: 'Exacte maten zijn nog niet beschikbaar voor dit product — gebruik in plaats daarvan de quiz hierboven.',
      errorEnterOne: 'Vul ten minste één maat in.', basedOn: 'Gebaseerd op', fitLabel: 'Pasvorm', fitPreference: 'Gewenste pasvorm',
      waistStretchHalf: 'Dit model heeft een halfelastische band, die doorgaans ongeveer 5–6 cm extra rek biedt.',
      waistStretchFull: 'Dit model heeft een volledig elastische band, die doorgaans ongeveer 7–9 cm extra rek biedt.',
      shouldersTitle: 'Jouw schouders', shouldersSubtitle: 'Bepaal je schouderbreedte, zodat we je perfecte pasvorm kunnen vinden.',
      chestTitle: 'Jouw borst', chestSubtitle: 'Bepaal je borstvorm, zodat we je perfecte pasvorm kunnen vinden.',
      waistTitle: 'Jouw taille', waistSubtitle: 'Bepaal je taillebreedte, zodat we je perfecte pasvorm kunnen vinden.',
      fitTitle: 'Jouw gewenste pasvorm', fitSubtitle: 'Bepaal je gewenste pasvorm, zodat we je perfecte maat kunnen vinden.',
      hipsTitle: 'Jouw heupen', hipsSubtitle: 'Bepaal je heupbreedte, zodat we je perfecte pasvorm kunnen vinden.',
      slimmer: 'Smaller', average: 'Gemiddeld', wider: 'Breder', flatter: 'Platter', broader: 'Breder', tighter: 'Strakker', looser: 'Losser', narrower: 'Smaller'
    }
  };

  var t = I18N[LOCALE] || I18N.en;

  var COMMON_AREA_KEYWORDS = ['bust', 'chest', 'waist', 'hip'];

  // Size-chart row labels are rendered in the storefront's own language, so matching
  // must not assume English words like "waist" or "hip" appear in the label text.
  var AREA_KEYWORD_SYNONYMS = {
    bust: ['bust', 'poitrine', 'buste', 'brust', 'borst'],
    chest: ['chest', 'poitrine', 'brust', 'borst'],
    waist: ['waist', 'taille'],
    hip: ['hip', 'hanche', 'huft', 'hüft', 'heup'],
    bicep: ['bicep', 'biceps', 'bizeps', 'bovenarm']
  };

  function keywordMatches(label, keyword) {
    var l = label.toLowerCase();
    var synonyms = AREA_KEYWORD_SYNONYMS[keyword] || [keyword];
    return synonyms.some(function (syn) { return l.indexOf(syn) !== -1; });
  }

  function isCommonArea(label) {
    return COMMON_AREA_KEYWORDS.some(function (k) { return keywordMatches(label, k); });
  }

  var PRODUCT_MEASUREMENTS = {
    'aurora dress': { areas: [['bust'], ['waist']] },
    'vila slip dress': { areas: [['bust'], ['hip']] },
    'valencia smocked dress': { areas: [['bust'], ['hip']] },
    'sarah pleated dress': { areas: [['bust'], ['waist']] },
    'luna wrap dress': { areas: [['bust'], ['waist']] },
    'nola dress with ties': { areas: [['bust'], ['hip']] },
    'olivia wrap dress': { areas: [['chest', 'bust'], ['hip']] },
    'rome wrap dress': { areas: [['chest', 'bust'], ['hip']] },
    'amalia long dress': { areas: [['bust'], ['hip']] },
    'sofia midi length dress': { areas: [['bust'], ['waist']] },
    'jakarta long dress': { areas: [['bust'], ['hip']] },
    'norah loose dress': { areas: [['bust'], ['hip']] },
    'zoe slip dress': { areas: [['bust'], ['hip']] },
    'ines slip dress': { areas: [['bust'], ['hip']] },
    'nina one-shoulder top': { areas: [['bust'], ['waist']] },
    'amora tie-neck top': { areas: [['bust']] },
    'camila halter top': { areas: [['bust']] },
    'ava lace-back top': { areas: [['bust']] },
    'vivien tie front top': { areas: [['bust'], ['bicep']] },
    'odette drawstring top': { areas: [['bust'], ['waist']] },
    'daria halter top': { areas: [['bust']] },
    'lola strap top': { areas: [['bust']] },
    'aura sleeveless top': { areas: [['bust']] },
    'maris button top': { areas: [['bust']] },
    'eloise gathered top': { areas: [['bust'], ['waist']] },
    'serena tie top': { areas: [['bust']] },
    'greta vest': { areas: [['bust'], ['waist']] },
    'rosie top with ties': { areas: [['bust']] },
    'ella pinafore top': { areas: [['bust']] },
    'blanca wrap top': { areas: [['bust'], ['waist'], ['hip']] },
    'elisa wrap top': { areas: [['bust']] },
    'adele wrap top': { areas: [['bust']] },
    'molly oversized shirt': { areas: [['bust'], ['bicep']] },
    'hilo top': { areas: [['bust']] },
    'maeve button top': { areas: [['bust']] },
    'lisa crop top': { areas: [['bust']] },
    'colette classic top': { areas: [['bust']] },
    'lucia classic top': { areas: [['bust']] },
    'pippa crop top': { areas: [['bust']] },
    'lily oversized top': { areas: [['bust']] },
    'porto oversized top': { areas: [['bust']] },
    'nordkapp classic shirt': { areas: [['bust'], ['bicep']] },
    'manon skirt with ties': { areas: [['waist'], ['hip']] },
    'ravena gathered skirt': { areas: [['waist'], ['hip']] },
    'gaia tie pants': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'vera classic straight pants': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'vittoria cropped pants': { areas: [['waist'], ['hip']] },
    'leona classic shorts': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'ivy mini skirt': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'tokyo wide pants': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'mia shorts': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'iris wrap skirt': { areas: [['waist'], ['hip']] },
    'leah pants with slits': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'ciara slip skirt': { areas: [['waist']], waistStretch: 'full' },
    'mona maxi skirt': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'lydia classic wide pants': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'barbora straight pants': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'betty classic shorts': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'isabella wide pants': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'malmo straight pants': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'bergen mid length skirt': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'daisy skirt': { areas: [['waist']], waistStretch: 'full' },
    'oulu long pants': { areas: [['waist']], waistStretch: 'full' },
    'nightly pajamas': { areas: [['bust'], ['waist'], ['hip']], waistStretch: 'full' },
    'midnight bathrobe': { areas: [['bust'], ['hip']] },
    'snooze pajamas': { areas: [['bust'], ['waist'], ['hip']], waistStretch: 'full' },
    'dreamy night gown': { areas: [['bust']] },
    'cloud nine pajamas': { areas: [['bust'], ['waist'], ['hip']], waistStretch: 'full' },
    'night owl pajamas': { areas: [['bust'], ['waist'], ['hip']], waistStretch: 'full' },
    'julian button shirt': { areas: [['chest', 'bust'], ['waist'], ['bicep']] },
    'hector classic shirt': { areas: [['chest', 'bust'], ['bicep']] },
    'magnus oversized shirt': { areas: [['chest', 'bust'], ['bicep']] },
    'atlas oversized top': { areas: [['chest', 'bust'], ['bicep']] },
    'cedar classic pants': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'marco pleated shorts': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'enzo pleated pants': { areas: [['waist'], ['hip']], waistStretch: 'half' },
    'adonis classic pants': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'hermes classic shorts': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'ares casual shorts': { areas: [['waist'], ['hip']], waistStretch: 'full' },
    'oliver loungewear set': { areas: [['chest', 'bust'], ['waist'], ['hip']], waistStretch: 'full' },
    'leo pajamas': { areas: [['chest', 'bust'], ['waist'], ['hip']], waistStretch: 'full' },
    'harry pajamas': { areas: [['chest', 'bust'], ['waist'], ['hip']], waistStretch: 'full' },
    'aspen loungewear set': { areas: [['chest', 'bust'], ['waist'], ['hip']], waistStretch: 'full' }
  };

  var PRODUCT_ID_TO_TITLE = {
    '9033538765137': 'aurora dress', '9941908062545': 'aurora dress', '9941921923409': 'aurora dress', '9941936046417': 'aurora dress', '10679232725329': 'aurora dress',
    '10699054874961': 'valencia smocked dress', '10699064344913': 'valencia smocked dress', '10699065622865': 'valencia smocked dress',
    '10704295493969': 'luna wrap dress', '10704310370641': 'luna wrap dress', '10704313385297': 'luna wrap dress',
    '10704320921937': 'nola dress with ties', '10704325673297': 'nola dress with ties', '10704327737681': 'nola dress with ties',
    '10705104109905': 'sarah pleated dress', '10705113907537': 'sarah pleated dress', '10705117774161': 'sarah pleated dress',
    '10705124196689': 'vila slip dress', '10705140285777': 'vila slip dress', '10705143890257': 'vila slip dress',
    '6912578813996': 'jakarta long dress', '9940677460305': 'jakarta long dress', '9940699742545': 'jakarta long dress',
    '8344839127377': 'olivia wrap dress', '9941822898513': 'olivia wrap dress', '9941827846481': 'olivia wrap dress',
    '9033538175313': 'amalia long dress', '9941870281041': 'amalia long dress', '9941878341969': 'amalia long dress',
    '9033539060049': 'sofia midi length dress', '9938033344849': 'sofia midi length dress',
    '9033540501841': 'norah loose dress', '9940659175761': 'norah loose dress',
    '9940597375313': 'rome wrap dress',
    '8340298924369': 'zoe slip dress', '9940538655057': 'zoe slip dress', '9940549861713': 'zoe slip dress',
    '9033541255505': 'ines slip dress', '10558903124305': 'ines slip dress', '10558913151313': 'ines slip dress',
    '10699114545489': 'camila halter top', '10699134337361': 'camila halter top',
    '10699154489681': 'amora tie-neck top', '10699182408017': 'amora tie-neck top', '10699191124305': 'amora tie-neck top', '10699195547985': 'amora tie-neck top',
    '10704638574929': 'ava lace-back top', '10704646242641': 'ava lace-back top', '10704648995153': 'ava lace-back top', '10704653451601': 'ava lace-back top',
    '10704988471633': 'nina one-shoulder top', '10704992502097': 'nina one-shoulder top', '10704995647825': 'nina one-shoulder top',
    '10685138436433': 'vivien tie front top', '10692310860113': 'vivien tie front top', '10692318331217': 'vivien tie front top', '10692326293841': 'vivien tie front top',
    '10692418339153': 'odette drawstring top', '10692442194257': 'odette drawstring top', '10699102912849': 'odette drawstring top',
    '10704380166481': 'daria halter top', '10704394486097': 'daria halter top', '10704396648785': 'daria halter top', '10704399368529': 'daria halter top',
    '10704390324561': 'aura sleeveless top', '10704412279121': 'aura sleeveless top',
    '10704418373969': 'lola strap top', '10704431808849': 'lola strap top',
    '10704683729233': 'maris button top', '10704701686097': 'maris button top', '10704709124433': 'maris button top',
    '8340298662225': 'ella pinafore top', '9945073385809': 'ella pinafore top', '9945087508817': 'ella pinafore top', '9945099829585': 'ella pinafore top',
    '9033540239697': 'blanca wrap top', '9942639313233': 'blanca wrap top', '9942646882641': 'blanca wrap top', '9942664216913': 'blanca wrap top', '10674279219537': 'blanca wrap top',
    '9033540927825': 'rosie top with ties', '9942343516497': 'rosie top with ties', '9942351741265': 'rosie top with ties', '10684742926673': 'rosie top with ties',
    '9064492433745': 'greta vest', '9943039541585': 'greta vest', '10674299863377': 'greta vest',
    '10704973398353': 'serena tie top', '10704977494353': 'serena tie top',
    '10704980246865': 'eloise gathered top', '10704983327057': 'eloise gathered top', '10704984539473': 'eloise gathered top',
    '6912578486316': 'hilo top', '9958171115857': 'hilo top',
    '8340298498385': 'lisa crop top', '9953767391569': 'lisa crop top', '9953774436689': 'lisa crop top',
    '9033540403537': 'maeve button top', '9942707994961': 'maeve button top', '9942741549393': 'maeve button top', '9942747480401': 'maeve button top',
    '9033540763985': 'molly oversized shirt', '9956093165905': 'molly oversized shirt', '9956095525201': 'molly oversized shirt', '9956098015569': 'molly oversized shirt',
    '9033540993361': 'elisa wrap top', '9942573056337': 'elisa wrap top', '9942600122705': 'elisa wrap top', '9942613393745': 'elisa wrap top',
    '9033541091665': 'adele wrap top', '9942478782801': 'adele wrap top', '10674304319825': 'adele wrap top',
    '6912578584620': 'porto oversized top', '9958383550801': 'porto oversized top',
    '6981874286636': 'nordkapp classic shirt',
    '8340298432849': 'pippa crop top', '9953915797841': 'pippa crop top', '9953937785169': 'pippa crop top',
    '8340298531153': 'colette classic top', '9953712144721': 'colette classic top', '9953718042961': 'colette classic top',
    '9033539289425': 'lily oversized top', '9953401930065': 'lily oversized top',
    '9033539977553': 'lucia classic top', '9944947491153': 'lucia classic top', '9944951750993': 'lucia classic top', '9944957321553': 'lucia classic top', '9944959942993': 'lucia classic top',
    '10692402676049': 'vera classic straight pants', '10694372262225': 'vera classic straight pants', '10694392643921': 'vera classic straight pants', '10694401950033': 'vera classic straight pants',
    '10694407815505': 'leona classic shorts', '10694450315601': 'leona classic shorts', '10694462636369': 'leona classic shorts', '10694469517649': 'leona classic shorts',
    '10699218026833': 'vittoria cropped pants', '10699236966737': 'vittoria cropped pants', '10699245453649': 'vittoria cropped pants', '10699256594769': 'vittoria cropped pants',
    '10705003118929': 'gaia tie pants', '10705013604689': 'gaia tie pants', '10705016193361': 'gaia tie pants',
    '10705027826001': 'ravena gathered skirt', '10705040736593': 'ravena gathered skirt', '10705044963665': 'ravena gathered skirt',
    '10705076846929': 'manon skirt with ties', '10705085432145': 'manon skirt with ties', '10705089069393': 'manon skirt with ties',
    '6912578322476': 'tokyo wide pants', '9955371516241': 'tokyo wide pants', '9955383673169': 'tokyo wide pants', '9955387015505': 'tokyo wide pants',
    '8340298694993': 'mia shorts', '9955414606161': 'mia shorts', '9956027203921': 'mia shorts', '9956036116817': 'mia shorts', '10679382540625': 'mia shorts',
    '8340299186513': 'iris wrap skirt', '9955825484113': 'iris wrap skirt', '9955903570257': 'iris wrap skirt', '9955990831441': 'iris wrap skirt',
    '9033539584337': 'ciara slip skirt', '9944902369617': 'ciara slip skirt', '9944923504977': 'ciara slip skirt', '9944926617937': 'ciara slip skirt',
    '9033540731217': 'leah pants with slits', '9942776447313': 'leah pants with slits', '9942784999761': 'leah pants with slits', '9942791979345': 'leah pants with slits', '9942801580369': 'leah pants with slits',
    '10704239133009': 'ivy mini skirt', '10704275046737': 'ivy mini skirt', '10704283795793': 'ivy mini skirt',
    '6912578388012': 'malmo straight pants', '9955788423505': 'malmo straight pants', '9955793174865': 'malmo straight pants',
    '8340298760529': 'isabella wide pants', '9953993458001': 'isabella wide pants', '9954010562897': 'isabella wide pants',
    '9033539780945': 'mona maxi skirt', '9944935432529': 'mona maxi skirt', '9944937234769': 'mona maxi skirt',
    '9033540305233': 'betty classic shorts', '9942426845521': 'betty classic shorts', '9942433956177': 'betty classic shorts', '9942441886033': 'betty classic shorts',
    '9033540567377': 'barbora straight pants', '9942370648401': 'barbora straight pants', '9942396830033': 'barbora straight pants', '9942405382481': 'barbora straight pants', '9942407872849': 'barbora straight pants',
    '9033541058897': 'lydia classic wide pants', '9943248044369': 'lydia classic wide pants', '9943251910993': 'lydia classic wide pants', '9943256498513': 'lydia classic wide pants', '9943274717521': 'lydia classic wide pants', '10679458955601': 'lydia classic wide pants',
    '6981874483244': 'bergen mid length skirt', '9955436462417': 'bergen mid length skirt',
    '6981874516012': 'oulu long pants', '9955762110801': 'oulu long pants',
    '6983828176940': 'midnight bathrobe', '9956356391249': 'midnight bathrobe', '10685207314769': 'midnight bathrobe',
    '6983828504620': 'snooze pajamas', '9956197663057': 'snooze pajamas', '9956206805329': 'snooze pajamas', '9956215685457': 'snooze pajamas', '10685209510225': 'snooze pajamas',
    '6983828766764': 'nightly pajamas', '9956294623569': 'nightly pajamas', '9956303241553': 'nightly pajamas', '9956310810961': 'nightly pajamas', '10685218423121': 'nightly pajamas',
    '8340298858833': 'daisy skirt', '9954058731857': 'daisy skirt',
    '6983829094444': 'cloud nine pajamas', '9956473340241': 'cloud nine pajamas', '9958016254289': 'cloud nine pajamas', '10685229564241': 'cloud nine pajamas',
    '6983829323820': 'night owl pajamas', '9958058295633': 'night owl pajamas', '10685240836433': 'night owl pajamas',
    '6983829651500': 'dreamy night gown', '9958102204753': 'dreamy night gown', '9958116032849': 'dreamy night gown', '10685248667985': 'dreamy night gown',
    '8639976833361': 'magnus oversized shirt', '9961298035025': 'magnus oversized shirt', '10685130899793': 'magnus oversized shirt', '10685280682321': 'magnus oversized shirt',
    '8639977029969': 'hector classic shirt', '9961469247825': 'hector classic shirt', '9961471312209': 'hector classic shirt', '10685290053969': 'hector classic shirt',
    '10704335962449': 'julian button shirt', '10704357163345': 'julian button shirt', '10704360571217': 'julian button shirt', '10704364962129': 'julian button shirt',
    '8639976767825': 'atlas oversized top', '9961478226257': 'atlas oversized top', '9961480847697': 'atlas oversized top', '10685298737489': 'atlas oversized top',
    '8639976964433': 'hermes classic shorts', '9961290432849': 'hermes classic shorts', '10558727979345': 'hermes classic shorts',
    '8639977390417': 'adonis classic pants', '9961259336017': 'adonis classic pants', '9961262186833': 'adonis classic pants', '10558726930769': 'adonis classic pants',
    '10705153786193': 'marco pleated shorts', '10705167417681': 'marco pleated shorts', '10705173250385': 'marco pleated shorts',
    '10705185309009': 'enzo pleated pants', '10705200611665': 'enzo pleated pants', '10705306943825': 'enzo pleated pants',
    '10705203069265': 'cedar classic pants', '10705209459025': 'cedar classic pants', '10705220305233': 'cedar classic pants',
    '8639977193809': 'ares casual shorts', '10558726996305': 'ares casual shorts', '10558727061841': 'ares casual shorts',
    '9793165656401': 'oliver loungewear set', '9958815465809': 'oliver loungewear set', '9958827655505': 'oliver loungewear set', '10685271933265': 'oliver loungewear set',
    '9793165787473': 'harry pajamas', '9958617317713': 'harry pajamas', '9958797181265': 'harry pajamas',
    '9958899777873': 'aspen loungewear set', '9958904824145': 'aspen loungewear set',
    '9958916358481': 'leo pajamas', '9958987825489': 'leo pajamas', '10685276488017': 'leo pajamas'
  };

  var WAIST_STRETCH_NOTES = { half: t.waistStretchHalf, full: t.waistStretchFull };

  function normalizeTitle(str) { return (str || '').trim().toLowerCase().replace(/\s+/g, ' '); }

  function getCurrentProductTitle() {
    var el = document.querySelector('.product__title') || document.querySelector('h1');
    return el ? el.textContent.trim() : '';
  }

  function getCurrentProductId() {
    try {
      var p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      return p && p.id != null ? String(p.id) : null;
    } catch (e) { return null; }
  }

  function getProductMeasurementConfig() {
    var id = getCurrentProductId();
    var key = id && PRODUCT_ID_TO_TITLE[id];
    if (!key) key = normalizeTitle(getCurrentProductTitle());
    return PRODUCT_MEASUREMENTS[key] || null;
  }

  function convertUnit(value, fromUnit, toUnit) {
    if (fromUnit === toUnit || !isFinite(value)) return value;
    if (fromUnit === 'cm' && toUnit === 'in') return value / CM_PER_IN;
    if (fromUnit === 'in' && toUnit === 'cm') return value * CM_PER_IN;
    if (fromUnit === 'kg' && toUnit === 'lb') return value * LB_PER_KG;
    if (fromUnit === 'lb' && toUnit === 'kg') return value / LB_PER_KG;
    return value;
  }

  function roundTo(value, decimals) { var f = Math.pow(10, decimals); return Math.round(value * f) / f; }

  function parseSizeChart() {
    var areas = {}; var sizes = []; var tables = document.querySelectorAll('table');
    Array.prototype.slice.call(tables).forEach(function (table) {
      var rows = Array.prototype.slice.call(table.querySelectorAll('tr')).map(function (tr) {
        return Array.prototype.slice.call(tr.children).map(function (c) { return c.textContent.trim(); });
      });
      if (!rows.length) return;
      var header = rows[0]; var sizeLabels = header.slice(1);
      if (!sizeLabels.length) return;
      for (var r = 1; r < rows.length; r++) {
        var row = rows[r]; var label = row[0]; var values = row.slice(1);
        if (!label || values.length !== sizeLabels.length) continue;
        var allNumeric = values.every(function (v) { return /^\d+(\.\d+)?$/.test(v); });
        if (!allNumeric) continue;
        if (!areas[label]) {
          areas[label] = {};
          sizeLabels.forEach(function (sz, idx) { areas[label][sz] = parseFloat(values[idx]); });
          if (!sizes.length) sizes = sizeLabels;
        }
      }
    });
    return { areas: areas, sizes: sizes };
  }

  var BODY_BASE =
    '<circle cx="60" cy="18" r="13" stroke="#c9c2b4" stroke-width="1.6"/>' +
    '<path d="M53 29 Q60 33 67 29" stroke="#c9c2b4" stroke-width="1.6" stroke-linecap="round"/>' +
    '<path d="M33 45 Q24 52 24 64 Q22 84 33 101 Q27 116 27 130 L27 152 Q60 161 93 152 L93 130 Q93 116 87 101 Q98 84 96 64 Q96 52 87 45 Q78 39 60 39 Q42 39 33 45 Z" fill="#faf8f5" stroke="#c9c2b4" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M33 45 Q19 54 17 76 Q16 92 21 108" fill="none" stroke="#c9c2b4" stroke-width="1.6" stroke-linecap="round"/>' +
    '<path d="M87 45 Q101 54 103 76 Q104 92 99 108" fill="none" stroke="#c9c2b4" stroke-width="1.6" stroke-linecap="round"/>' +
    '<path d="M45 45 Q44 38 48 33" fill="none" stroke="#c9a48a" stroke-width="1.5" stroke-linecap="round"/>' +
    '<path d="M75 45 Q76 38 72 33" fill="none" stroke="#c9a48a" stroke-width="1.5" stroke-linecap="round"/>' +
    '<path d="M60 50 Q41 50 36 63 Q39 74 60 78 Q81 74 84 63 Q79 50 60 50 Z" fill="#f3e6db" stroke="#c9a48a" stroke-width="1.4" stroke-linejoin="round"/>' +
    '<path d="M60 51 L60 77" stroke="#c9a48a" stroke-width="1.2"/>';

  var ICON_SHOULDERS = '<svg viewBox="0 0 120 170" fill="none" xmlns="http://www.w3.org/2000/svg">' + BODY_BASE + '<g class="size-finder__icon-scale"><path d="M30 46 Q60 35 90 46" fill="none" stroke="#c0392b" stroke-width="2.4" stroke-linecap="round"/><path d="M20 39 Q13 43 14 52" fill="none" stroke="#c0392b" stroke-width="2" stroke-linecap="round"/><path d="M11 48 L14 52 L18 47" fill="none" stroke="#c0392b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M100 39 Q107 43 106 52" fill="none" stroke="#c0392b" stroke-width="2" stroke-linecap="round"/><path d="M109 48 L106 52 L102 47" fill="none" stroke="#c0392b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
  var ICON_CHEST = '<svg viewBox="0 0 120 170" fill="none" xmlns="http://www.w3.org/2000/svg">' + BODY_BASE + '<g class="size-finder__icon-scale"><ellipse cx="60" cy="64" rx="30" ry="9" fill="none" stroke="#c0392b" stroke-width="2.2" stroke-dasharray="4 3"/></g></svg>';
  var ICON_WAIST = '<svg viewBox="0 0 120 170" fill="none" xmlns="http://www.w3.org/2000/svg">' + BODY_BASE + '<g class="size-finder__icon-scale"><ellipse cx="60" cy="102" rx="33" ry="8" fill="none" stroke="#c0392b" stroke-width="2.2" stroke-dasharray="4 3"/></g></svg>';
  var ICON_HIPS = '<svg viewBox="0 0 120 170" fill="none" xmlns="http://www.w3.org/2000/svg">' + BODY_BASE + '<g class="size-finder__icon-scale"><ellipse cx="60" cy="131" rx="38" ry="9" fill="none" stroke="#c0392b" stroke-width="2.2" stroke-dasharray="4 3"/></g></svg>';
  var ICON_FIT = '<svg viewBox="0 0 120 170" fill="none" xmlns="http://www.w3.org/2000/svg">' + BODY_BASE + '<g class="size-finder__icon-scale"><path d="M21 49 Q10 59 12 79 Q9 104 22 124 L17 158 Q60 169 103 158 L98 124 Q111 104 108 79 Q110 59 99 49 Q84 39 60 39 Q36 39 21 49 Z" fill="none" stroke="#c0392b" stroke-width="2" stroke-dasharray="4 3" stroke-linejoin="round"/></g></svg>';

  function buildTopQuizSteps() {
    return [
      { key: 'shoulders', title: t.shouldersTitle, subtitle: t.shouldersSubtitle, icon: ICON_SHOULDERS, options: [ { value: 'slimmer', label: t.slimmer, score: -1 }, { value: 'average', label: t.average, score: 0 }, { value: 'wider', label: t.wider, score: 1 } ] },
      { key: 'chest', title: t.chestTitle, subtitle: t.chestSubtitle, icon: ICON_CHEST, options: [ { value: 'flatter', label: t.flatter, score: -1 }, { value: 'average', label: t.average, score: 0 }, { value: 'broader', label: t.broader, score: 1 } ] },
      { key: 'waist', title: t.waistTitle, subtitle: t.waistSubtitle, icon: ICON_WAIST, options: [ { value: 'slimmer', label: t.slimmer, score: -1 }, { value: 'average', label: t.average, score: 0 }, { value: 'wider', label: t.wider, score: 1 } ] },
      { key: 'fit', title: t.fitTitle, subtitle: t.fitSubtitle, icon: ICON_FIT, options: [ { value: 'tighter', label: t.tighter, score: -1 }, { value: 'average', label: t.average, score: 0 }, { value: 'looser', label: t.looser, score: 1 } ] }
    ];
  }

  function buildBottomQuizSteps() {
    return [
      { key: 'waist', title: t.waistTitle, subtitle: t.waistSubtitle, icon: ICON_WAIST, options: [ { value: 'slimmer', label: t.slimmer, score: -1 }, { value: 'average', label: t.average, score: 0 }, { value: 'wider', label: t.wider, score: 1 } ] },
      { key: 'hips', title: t.hipsTitle, subtitle: t.hipsSubtitle, icon: ICON_HIPS, options: [ { value: 'narrower', label: t.narrower, score: -1 }, { value: 'average', label: t.average, score: 0 }, { value: 'wider', label: t.wider, score: 1 } ] },
      { key: 'fit', title: t.fitTitle, subtitle: t.fitSubtitle, icon: ICON_FIT, options: [ { value: 'tighter', label: t.tighter, score: -1 }, { value: 'average', label: t.average, score: 0 }, { value: 'looser', label: t.looser, score: 1 } ] }
    ];
  }

  function isBottomGarment(config) {
    if (!config) return false;
    return !config.areas.some(function (group) { return group.indexOf('bust') !== -1 || group.indexOf('chest') !== -1; });
  }

  function buildStepOrder(quizSteps) {
    return ['form', 'measure'].concat(quizSteps.map(function (s) { return s.key; })).concat(['result']);
  }

  function pillsHtml(step) {
    return step.options.map(function (opt) {
      return '<button type="button" class="size-finder__pill' + (opt.value === 'average' ? ' is-selected' : '') +
        '" data-pill-group="' + step.key + '" data-pill-value="' + opt.value + '" data-pill-label="' + opt.label + '" data-pill-score="' + opt.score + '">' +
        opt.label + '</button>';
    }).join('');
  }

  function quizStepHtml(step, index, totalSteps) {
    return (
      '<div class="size-finder__step" data-size-finder-step="' + step.key + '" hidden>' +
        '<div class="size-finder__progress"><div class="size-finder__progress-bar" style="width:' + Math.round(((index + 1) / (totalSteps + 1)) * 100) + '%"></div></div>' +
        (step.icon ? '<div class="size-finder__icon">' + step.icon + '</div>' : '') +
        '<h2 class="size-finder__title">' + step.title + '</h2>' +
        '<p class="size-finder__subtitle">' + step.subtitle + '</p>' +
        '<div class="size-finder__pills" data-pill-row="' + step.key + '">' + pillsHtml(step) + '</div>' +
        '<div class="size-finder__btn-row">' +
          '<button type="button" class="size-finder__back" data-quiz-back="' + step.key + '">' + t.back + '</button>' +
          '<button type="button" class="size-finder__submit" data-quiz-continue="' + step.key + '">' + t.continueBtn + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function buildWidgetHtml(quizSteps) {
    return (
    '<div class="size-finder" data-size-finder>' +
      '<button type="button" class="size-finder__opener" data-size-finder-open>' +
        '<span class="size-finder__opener-label">' + t.opener + '</span>' +
      '</button>' +
      '<div class="size-finder__overlay" data-size-finder-overlay>' +
        '<div class="size-finder__modal" role="dialog" aria-modal="true" aria-labelledby="size-finder-title">' +
          '<button type="button" class="size-finder__close" data-size-finder-close aria-label="' + t.close + '">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<div class="size-finder__step" data-size-finder-step="form">' +
            '<h2 id="size-finder-title" class="size-finder__title">' + t.modalTitle + '</h2>' +
            '<p class="size-finder__subtitle">' + t.modalSubtitle + '</p>' +
            '<div class="size-finder__row">' +
              '<label class="size-finder__field"><span>' + t.age + '</span>' +
                '<input type="number" inputmode="numeric" min="10" max="100" data-size-finder-input="age" placeholder="29"></label>' +
              '<label class="size-finder__field"><span>' + t.gender + '</span>' +
                '<select data-size-finder-input="gender"><option value="female">' + t.female + '</option><option value="male">' + t.male + '</option><option value="prefer-not-to-say">' + t.preferNotToSay + '</option></select></label>' +
            '</div>' +
            '<div class="size-finder__row">' +
              '<label class="size-finder__field"><span>' + t.height + '</span>' +
                '<div class="size-finder__input-unit">' +
                  '<input type="number" inputmode="decimal" data-size-finder-input="height" placeholder="168">' +
                  '<select class="size-finder__unit-select" data-size-finder-unit="height"><option value="cm" selected>cm</option><option value="in">in</option></select>' +
                '</div>' +
              '</label>' +
              '<label class="size-finder__field"><span>' + t.weight + '</span>' +
                '<div class="size-finder__input-unit">' +
                  '<input type="number" inputmode="decimal" data-size-finder-input="weight" placeholder="60">' +
                  '<select class="size-finder__unit-select" data-size-finder-unit="weight"><option value="kg" selected>kg</option><option value="lb">lb</option></select>' +
                '</div>' +
              '</label>' +
            '</div>' +
            '<button type="button" class="size-finder__submit" data-size-finder-submit>' + t.continueBtn + '</button>' +
            '<p class="size-finder__error" data-size-finder-error hidden></p>' +
            '<button type="button" class="size-finder__link" data-size-finder-measure-link>' + t.orEnterExact + '</button>' +
          '</div>' +
          '<div class="size-finder__step" data-size-finder-step="measure" hidden>' +
            '<h2 class="size-finder__title">' + t.measureTitle + '</h2>' +
            '<p class="size-finder__subtitle">' + t.measureSubtitle + '</p>' +
            '<div data-size-finder-measure-fields></div>' +
            '<button type="button" class="size-finder__submit" data-size-finder-measure-continue>' + t.continueBtn + '</button>' +
            '<p class="size-finder__error" data-size-finder-measure-error hidden></p>' +
            '<button type="button" class="size-finder__link" data-size-finder-measure-back>' + t.back + '</button>' +
          '</div>' +
          quizSteps.map(function (step, index) { return quizStepHtml(step, index, quizSteps.length); }).join('') +
          '<div class="size-finder__step" data-size-finder-step="result" hidden>' +
            '<h2 class="size-finder__title">' + t.resultTitle + '</h2>' +
            '<p class="size-finder__subtitle">' + t.resultSubtitle + '</p>' +
            '<div class="size-finder__result-size" data-size-finder-result-size></div>' +
            '<div class="size-finder__scale" data-size-finder-scale></div>' +
            '<p class="size-finder__fit-caption" data-size-finder-fit-caption></p>' +
            '<button type="button" class="size-finder__submit" data-size-finder-select>' + t.selectThisSize + '</button>' +
            '<button type="button" class="size-finder__restart" data-size-finder-restart>' + t.tryAgain + '</button>' +
            '<p class="size-finder__disclaimer">' + t.disclaimer + '</p>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>'
    );
  }

  function normalize(str) { return (str || '').trim().toUpperCase(); }

  function bmiOf(heightCm, weightKg) { var heightM = heightCm / 100; return weightKg / (heightM * heightM); }

  function bandIndexForBmi(bmi) {
    for (var i = 0; i < BMI_BANDS.length; i++) { if (bmi <= BMI_BANDS[i].max) return i; }
    return BMI_BANDS.length - 1;
  }

  function nearBoundary(bmi, index) {
    if (index > 0 && bmi - BMI_BANDS[index - 1].max <= BOUNDARY_MARGIN) return true;
    if (index < BMI_BANDS.length - 1 && BMI_BANDS[index].max - bmi <= BOUNDARY_MARGIN) return true;
    return false;
  }

  function baseIndexFor(heightCm, weightKg) {
    var bmi = bmiOf(heightCm, weightKg);
    var index = bandIndexForBmi(bmi);
    if (nearBoundary(bmi, index)) {
      if (heightCm >= TALL_CM) index = Math.min(index + 1, BMI_BANDS.length - 1);
      else if (heightCm <= PETITE_CM) index = Math.max(index - 1, 0);
    }
    return index;
  }

  function quizAdjustment(answers, quizSteps) {
    var total = 0; var count = 0;
    quizSteps.forEach(function (step) {
      var val = answers[step.key] && answers[step.key].score;
      if (val == null) return;
      total += val; count++;
    });
    if (!count) return 0;
    var avg = total / count;
    if (avg > 0.35) return 1;
    if (avg < -0.35) return -1;
    return 0;
  }

  function availableSizes() {
    var seen = {}; var sizes = [];
    Array.prototype.slice.call(document.querySelectorAll('input[type="radio"]')).forEach(function (input) {
      var v = normalize(input.value);
      if (SIZE_ORDER.indexOf(v) === -1 || seen[v]) return;
      seen[v] = true; sizes.push(v);
    });
    sizes.sort(function (a, b) { return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); });
    return sizes;
  }

  function closestAvailable(size, available) {
    if (!available.length) return size;
    if (available.indexOf(size) !== -1) return size;
    var target = SIZE_ORDER.indexOf(size); var best = available[0]; var bestDist = Infinity;
    available.forEach(function (s) { var d = Math.abs(SIZE_ORDER.indexOf(s) - target); if (d < bestDist) { bestDist = d; best = s; } });
    return best;
  }

  function selectVariantSize(sizeValue) {
    var input = Array.prototype.slice.call(document.querySelectorAll('input[type="radio"]'))
      .find(function (i) { return normalize(i.value) === normalize(sizeValue); });
    if (!input) return false;
    var label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
    if (label) { label.click(); } else {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    return true;
  }

  function isVisible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function findSizeGuideAnchor() {
    var candidatesBtn = Array.prototype.slice.call(document.querySelectorAll('.size-guide-btn'));
    var visibleBtn = candidatesBtn.find(isVisible);
    if (visibleBtn) return visibleBtn;
    if (candidatesBtn.length) return candidatesBtn[0];
    var candidates = Array.prototype.slice.call(document.querySelectorAll('modal-opener, button, summary'));
    var textMatches = candidates.filter(function (el) { return normalize(el.textContent).replace(/\s+/g, ' ') === 'SIZE GUIDE'; });
    return textMatches.find(isVisible) || textMatches[0] || null;
  }

  function buildMeasureFieldsHtml(areaNames, waistStretch) {
    return areaNames.map(function (area) {
      var esc = area.replace(/"/g, '&quot;');
      var note = (waistStretch && keywordMatches(area, 'waist'))
        ? '<p class="size-finder__measure-note">' + WAIST_STRETCH_NOTES[waistStretch] + '</p>'
        : '';
      return (
        '<label class="size-finder__field size-finder__field--full"><span>' + area + '</span>' +
          '<div class="size-finder__input-unit">' +
            '<input type="number" inputmode="decimal" data-size-finder-measure-input="' + esc + '" placeholder="e.g. 90">' +
            '<select class="size-finder__unit-select" data-size-finder-measure-unit="' + esc + '"><option value="cm" selected>cm</option><option value="in">in</option></select>' +
          '</div>' +
        '</label>' +
        note
      );
    }).join('');
  }

  function mount() {
    if (document.querySelector('[data-size-finder]')) return;
    var anchor = findSizeGuideAnchor();
    if (!anchor) return;
    if (!availableSizes().length) return;
    var config = getProductMeasurementConfig();
    var quizSteps = isBottomGarment(config) ? buildBottomQuizSteps() : buildTopQuizSteps();
    var stepOrder = buildStepOrder(quizSteps);
    var host = anchor.closest('modal-opener') || anchor;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildWidgetHtml(quizSteps);
    var widgetEl = wrapper.firstElementChild;
    host.parentNode.insertBefore(widgetEl, host.nextSibling);
    var overlay = widgetEl.querySelector('[data-size-finder-overlay]');
    if (overlay) document.body.appendChild(overlay);
    init(widgetEl, overlay, quizSteps, stepOrder);
  }

  function init(root, overlay, quizSteps, stepOrder) {
    overlay = overlay || root.querySelector('[data-size-finder-overlay]');
    var openBtn = root.querySelector('[data-size-finder-open]');
    var closeBtn = overlay.querySelector('[data-size-finder-close]');
    var submitBtn = overlay.querySelector('[data-size-finder-submit]');
    var errorEl = overlay.querySelector('[data-size-finder-error]');
    var resultSizeEl = overlay.querySelector('[data-size-finder-result-size]');
    var scaleEl = overlay.querySelector('[data-size-finder-scale]');
    var fitCaptionEl = overlay.querySelector('[data-size-finder-fit-caption]');
    var selectBtn = overlay.querySelector('[data-size-finder-select]');
    var restartBtn = overlay.querySelector('[data-size-finder-restart]');
    var measureLinkBtn = overlay.querySelector('[data-size-finder-measure-link]');
    var measureBackBtn = overlay.querySelector('[data-size-finder-measure-back]');
    var measureContinueBtn = overlay.querySelector('[data-size-finder-measure-continue]');
    var measureFieldsEl = overlay.querySelector('[data-size-finder-measure-fields]');
    var measureErrorEl = overlay.querySelector('[data-size-finder-measure-error]');

    function measureInputFor(area) {
      return Array.prototype.slice.call(overlay.querySelectorAll('[data-size-finder-measure-input]'))
        .find(function (el) { return el.getAttribute('data-size-finder-measure-input') === area; });
    }

    var steps = {};
    stepOrder.forEach(function (key) { steps[key] = overlay.querySelector('[data-size-finder-step="' + key + '"]'); });

    var answers = {}; var baseIndex = null; var bestSize = null;
    var units = { height: 'cm', weight: 'kg' };
    var measureUnits = {};
    var chart = null; var measurementMode = false; var measureBaseIndex = null; var measureSummary = ''; var currentAreaNames = [];

    function showStep(key) { stepOrder.forEach(function (k) { if (steps[k]) steps[k].hidden = (k !== key); }); }
    function openModal() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeModal() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    function fieldValue(key) { var el = overlay.querySelector('[data-size-finder-input="' + key + '"]'); return el ? el.value : ''; }
    function resetQuiz() {
      answers = {};
      Array.prototype.slice.call(overlay.querySelectorAll('.size-finder__pill')).forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.getAttribute('data-pill-value') === 'average');
      });
      Array.prototype.slice.call(overlay.querySelectorAll('.size-finder__icon-scale')).forEach(function (g) { g.style.transform = 'scaleX(1)'; });
    }
    function renderScale(size, list) {
      if (!list || !list.length) { list = availableSizes(); if (!list.length) list = SIZE_ORDER; }
      var idx = list.indexOf(size); if (idx === -1) idx = 0;
      var lower = list[idx - 1] || ''; var upper = list[idx + 1] || '';
      scaleEl.innerHTML = '<div class="size-finder__scale-track"><div class="size-finder__scale-marker"></div></div><div class="size-finder__scale-labels"><span>' + lower + '</span><span class="is-current">' + size + '</span><span>' + upper + '</span></div>';
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal(); });

    overlay.addEventListener('change', function (e) {
      var unitSelect = e.target.closest('[data-size-finder-unit]');
      if (unitSelect) {
        var key = unitSelect.getAttribute('data-size-finder-unit');
        var input = overlay.querySelector('[data-size-finder-input="' + key + '"]');
        var oldUnit = units[key]; var newUnit = unitSelect.value;
        if (input && input.value !== '') { var num = parseFloat(input.value); if (!isNaN(num)) input.value = roundTo(convertUnit(num, oldUnit, newUnit), 1); }
        units[key] = newUnit;
        return;
      }
      var measureUnitSel = e.target.closest('[data-size-finder-measure-unit]');
      if (measureUnitSel) {
        var area = measureUnitSel.getAttribute('data-size-finder-measure-unit');
        var measureInputEl = measureInputFor(area);
        var oldU = measureUnits[area] || 'cm'; var newU = measureUnitSel.value;
        if (measureInputEl && measureInputEl.value !== '') { var mNum = parseFloat(measureInputEl.value); if (!isNaN(mNum)) measureInputEl.value = roundTo(convertUnit(mNum, oldU, newU), 1); }
        measureUnits[area] = newU;
      }
    });

    overlay.addEventListener('click', function (e) {
      var pill = e.target.closest('.size-finder__pill');
      if (!pill) return;
      var group = pill.getAttribute('data-pill-group');
      Array.prototype.slice.call(overlay.querySelectorAll('[data-pill-group="' + group + '"]')).forEach(function (btn) { btn.classList.toggle('is-selected', btn === pill); });
      var score = parseFloat(pill.getAttribute('data-pill-score'));
      answers[group] = { score: score, label: pill.getAttribute('data-pill-label') };
      var stepEl = pill.closest('.size-finder__step');
      var scaleGroup = stepEl && stepEl.querySelector('.size-finder__icon-scale');
      if (scaleGroup) { var scale = score < 0 ? 0.86 : score > 0 ? 1.14 : 1; scaleGroup.style.transform = 'scaleX(' + scale + ')'; }
    });

    submitBtn.addEventListener('click', function () {
      errorEl.hidden = true;
      var heightRaw = parseFloat(fieldValue('height'));
      var weightRaw = parseFloat(fieldValue('weight'));
      if (!heightRaw || !weightRaw) { errorEl.hidden = false; errorEl.textContent = t.errorHeightWeight; return; }
      var height = convertUnit(heightRaw, units.height, 'cm');
      var weight = convertUnit(weightRaw, units.weight, 'kg');
      baseIndex = baseIndexFor(height, weight);
      measurementMode = false;
      resetQuiz();
      showStep(quizSteps[0].key);
    });

    measureLinkBtn.addEventListener('click', function () {
      var config = getProductMeasurementConfig();
      function matchedAreaNames(c) {
        if (!config) return Object.keys(c.areas).filter(isCommonArea);
        var names = [];
        config.areas.forEach(function (keywords) {
          var found = Object.keys(c.areas).find(function (name) {
            return keywords.some(function (k) { return keywordMatches(name, k); });
          });
          if (found && names.indexOf(found) === -1) names.push(found);
        });
        return names;
      }
      function populateAndShow(c) {
        var areaNames = matchedAreaNames(c);
        chart = { areas: {}, sizes: c.sizes };
        areaNames.forEach(function (name) { chart.areas[name] = c.areas[name]; });
        currentAreaNames = areaNames;
        measureUnits = {};
        areaNames.forEach(function (name) { measureUnits[name] = 'cm'; });
        if (!areaNames.length) { errorEl.hidden = false; errorEl.textContent = t.errorNoMeasurements; return; }
        measureFieldsEl.innerHTML = buildMeasureFieldsHtml(areaNames, config ? config.waistStretch : null);
        measureErrorEl.hidden = true;
        showStep('measure');
      }
      errorEl.hidden = true;
      var first = parseSizeChart();
      if (matchedAreaNames(first).length) { populateAndShow(first); } else { setTimeout(function () { populateAndShow(parseSizeChart()); }, 600); }
    });

    measureBackBtn.addEventListener('click', function () { showStep('form'); });

    measureContinueBtn.addEventListener('click', function () {
      measureErrorEl.hidden = true;
      var usedIndices = []; var usedDisplayParts = [];
      currentAreaNames.forEach(function (area) {
        var inputEl = measureInputFor(area);
        if (!inputEl || inputEl.value === '') return;
        var raw = parseFloat(inputEl.value);
        if (!raw || !chart.areas[area]) return;
        var unit = measureUnits[area] || 'cm';
        var valueCm = convertUnit(raw, unit, 'cm');
        var rowValues = chart.areas[area];
        var bestIdx = 0; var bestDiff = Infinity;
        chart.sizes.forEach(function (sz, idx) { var v = rowValues[sz]; if (v != null) { var diff = Math.abs(v - valueCm); if (diff < bestDiff) { bestDiff = diff; bestIdx = idx; } } });
        usedIndices.push(bestIdx);
        usedDisplayParts.push(area + ': ' + raw + ' ' + unit);
      });
      if (!usedIndices.length) { measureErrorEl.hidden = false; measureErrorEl.textContent = t.errorEnterOne; return; }
      var avgIdx = Math.round(usedIndices.reduce(function (a, b) { return a + b; }, 0) / usedIndices.length);
      avgIdx = Math.max(0, Math.min(chart.sizes.length - 1, avgIdx));
      measurementMode = true; measureBaseIndex = avgIdx; measureSummary = usedDisplayParts.join(', ');
      resetQuiz();
      showStep('fit');
    });

    quizSteps.forEach(function (step, i) {
      var backBtn = overlay.querySelector('[data-quiz-back="' + step.key + '"]');
      var continueBtn = overlay.querySelector('[data-quiz-continue="' + step.key + '"]');
      backBtn.addEventListener('click', function () {
        if (measurementMode && step.key === 'fit') { showStep('measure'); return; }
        showStep(i === 0 ? 'form' : quizSteps[i - 1].key);
      });
      continueBtn.addEventListener('click', function () {
        if (i < quizSteps.length - 1) { showStep(quizSteps[i + 1].key); return; }
        var adjustment = quizAdjustment(answers, quizSteps);
        if (measurementMode) {
          var idx2 = Math.max(0, Math.min(chart.sizes.length - 1, measureBaseIndex + adjustment));
          bestSize = chart.sizes[idx2];
          resultSizeEl.textContent = bestSize;
          renderScale(bestSize, chart.sizes);
          var fitAnswer2 = answers.fit ? answers.fit.label : t.average;
          fitCaptionEl.textContent = t.basedOn + ' ' + measureSummary + ' · ' + t.fitLabel + ': ' + fitAnswer2;
          showStep('result');
          return;
        }
        var index = Math.max(0, Math.min(BMI_BANDS.length - 1, baseIndex + adjustment));
        var size = BMI_BANDS[index].size;
        bestSize = closestAvailable(size, availableSizes());
        resultSizeEl.textContent = bestSize;
        renderScale(bestSize);
        var fitAnswer = answers.fit ? answers.fit.label : t.average;
        fitCaptionEl.textContent = t.fitPreference + ': ' + fitAnswer;
        showStep('result');
      });
    });

    restartBtn.addEventListener('click', function () { measurementMode = false; showStep('form'); });
    selectBtn.addEventListener('click', function () { if (bestSize) selectVariantSize(bestSize); closeModal(); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', mount); } else { mount(); }
  document.addEventListener('shopify:section:load', function () { setTimeout(mount, 50); });
})();
